import React from 'react';
import { useHistory } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const BackButton = () => {
  const history = useHistory();

  const handleRegresar = () => {
    history.goBack(); // Esta función te lleva a la página anterior en la historia del navegador.
  };


  return (
    <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver atras</Tooltip>}>
      <div className="div-back">
        <a onClick={handleRegresar}>
          <img src='/back.png' className="icon" alt="" />
        </a>
      </div>
    </OverlayTrigger>
  );
};

export default BackButton;


// WEBPACK FOOTER //
// ./src/components/widgets/back_button.jsx